"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var WrappedPropertyArray_1 = require("./WrappedPropertyArray");
exports.WrappedPropertyArray = WrappedPropertyArray_1.default;
var WrappedPropertyObject_1 = require("./WrappedPropertyObject");
exports.WrappedPropertyObject = WrappedPropertyObject_1.default;
var WrappedPropertyNumber_1 = require("./WrappedPropertyNumber");
exports.WrappedPropertyNumber = WrappedPropertyNumber_1.default;
var WrappedPropertyString_1 = require("./WrappedPropertyString");
exports.WrappedPropertyString = WrappedPropertyString_1.default;
var WrappedPropertyBoolean_1 = require("./WrappedPropertyBoolean");
exports.WrappedPropertyBoolean = WrappedPropertyBoolean_1.default;
var IOptions_1 = require("./IOptions");
var fixAndMergeSchema_1 = require("../JSchema/fixAndMergeSchema");
function wrap(parent, schema, propName, options) {
    // console.log('wrap');
    // napraw schema, rozwią refs i dodaj $parent
    var stime = new Date().getTime();
    // console.log('fixSchema', new Date().getTime() - stime);
    // czy schema było naprawioane czy nie
    if (Array.isArray(schema)) {
        schema = fixAndMergeSchema_1.default(schema);
    }
    else if (schema.$parent === undefined) {
        schema = fixAndMergeSchema_1.default([schema]);
    }
    // this.calcFunctions = [];
    // this.summaryFunctions = [];
    var mainprop;
    if (propName) {
        if (parent[propName].__ob__ === undefined && options.Vue) {
            options.Vue.observable(parent.propName);
        }
        mainprop = new WrappedPropertyObject_1.default(null, parent, propName, schema, IOptions_1.fixSchemaOptions(options));
    }
    else {
        var data = { model: parent };
        if (data.model.__ob__ === undefined && options.Vue) {
            options.Vue.observable(data.model);
        }
        mainprop = new WrappedPropertyObject_1.default(null, data, 'model', schema, IOptions_1.fixSchemaOptions(options));
    }
    return mainprop;
}
exports.wrap = wrap;
exports.default = WrappedPropertyCtor_1.default;
//# sourceMappingURL=index.js.map